import { periodToRange } from '../../api/dashboards'
import { productivityApi } from '../../api/productivity'
import { DataTable } from '../ui'
import type { WidgetProps } from './types'
import { useWidgetData } from './useWidgetData'
import { WidgetBody, formatNum, formatPct } from './WidgetBody'

/** Report per agente: lead, appuntamenti e attivazioni con la variazione sul periodo precedente. */
export function SalesAgentsWidget({ item }: WidgetProps) {
  const range = periodToRange(item.filters?.period)
  const teamOf = item.filters?.teamOf ? String(item.filters.teamOf) : undefined
  const state = useWidgetData(() => productivityApi.salesAgents({ ...range, teamOf }), JSON.stringify([range, teamOf]))
  return (
    <WidgetBody state={state}>
      {report => (
        <DataTable>
          <thead>
            <tr>
              <th>Agente</th>
              <th className="text-end">Lead</th>
              <th className="text-end">Variazione</th>
              <th className="text-end">Appuntamenti</th>
              <th className="text-end">Attivazioni</th>
            </tr>
          </thead>
          <tbody>
            {report.rows.map(r => {
              const leads = r.comparison.find(c => c.measure === 'totalLeads')
              return (
                <tr key={r.agentId}>
                  <td>{r.name ?? `Agente ${r.agentId}`}</td>
                  <td className="text-end md-num">{formatNum(r.current.stages.totalLeads)}</td>
                  <td className="text-end text-muted md-num">{leads ? formatPct(leads.deltaPct) : '—'}</td>
                  <td className="text-end md-num">{formatNum(r.current.stages.appointmentsCompleted)}</td>
                  <td className="text-end md-num">{formatNum(r.current.stages.activations)}</td>
                </tr>
              )
            })}
          </tbody>
        </DataTable>
      )}
    </WidgetBody>
  )
}
